(() => {
  if (typeof window.__dwilInitializeKlaviyoFormGuards === 'function') {
    window.__dwilInitializeKlaviyoFormGuards();
    return;
  }

  const FORM_HOST_SELECTOR = '.dwil-klaviyo-form__embed';

/** @type {WeakMap<HTMLElement, MutationObserver>} */
const hostObservers = new WeakMap();

/**
 * Returns the direct child of the Klaviyo host that owns an injected node.
 * @param {HTMLElement} host
 * @param {Element} node
 * @returns {Element}
 */
function getHostBranch(host, node) {
  let branch = node;

  while (branch.parentElement && branch.parentElement !== host) {
    branch = branch.parentElement;
  }

  return branch;
}

/**
 * Klaviyo can re-run its embed renderer after a Shopify variant update and
 * append another copy of the same form. Keep the first active form and its
 * live announcer while removing only duplicate injections inside this host.
 * @param {HTMLElement} host
 */
function removeDuplicateForms(host) {
  const forms = Array.from(host.querySelectorAll('form')).filter((form) =>
    form.querySelector('input[type="email"], input[name="email"]')
  );

  if (forms.length > 1) {
    const retainedForm = forms[0];

    forms.slice(1).forEach((form) => {
      const branch = getHostBranch(host, form);

      if (branch.parentElement === host && !branch.contains(retainedForm)) {
        branch.remove();
      } else {
        form.remove();
      }
    });
  }

  const announcers = Array.from(host.querySelectorAll('[data-testid="submit-announcer"]'));
  announcers.slice(1).forEach((announcer) => announcer.remove());
}

/**
 * @param {HTMLElement} host
 */
function initializeHost(host) {
  if (hostObservers.has(host)) return;

  let cleanupQueued = false;
  const scheduleCleanup = () => {
    if (cleanupQueued) return;
    cleanupQueued = true;

    queueMicrotask(() => {
      cleanupQueued = false;
      if (host.isConnected) removeDuplicateForms(host);
    });
  };

  const observer = new MutationObserver(scheduleCleanup);
  observer.observe(host, { childList: true, subtree: true });
  hostObservers.set(host, observer);

  scheduleCleanup();
}

function initializeKlaviyoFormGuards() {
  document.querySelectorAll(FORM_HOST_SELECTOR).forEach((host) => {
    if (host instanceof HTMLElement) initializeHost(host);
  });
}

  window.__dwilInitializeKlaviyoFormGuards = initializeKlaviyoFormGuards;
  initializeKlaviyoFormGuards();
  document.addEventListener('shopify:section:load', initializeKlaviyoFormGuards);
})();
